import { Pipe, PipeTransform } from '@angular/core';
import { LangProvider } from './lang.provider';

@Pipe({
  name: 'lang',
  pure: true
})
export class LangPipe implements PipeTransform {

  constructor(private _langP: LangProvider) { }

  transform(value: any, _args?: any): any {
    return this._langP.getTranslationSync(value);
  }

}
